import { WtuReason } from "../models/wtu-reason";
export var setDefaultReportPageInfo = function (model, spotName) {
    model.pageUrl = document.location.href;
    model.reason = WtuReason.Broken;
    model.spotName = spotName;
    model.useful = false;
};
